<template>
	<div>
		<el-drawer
			:title="`${data.projectName} -  项目详情`"
			:visible.sync="dialogVisible"
			size="45%"
			:close-on-click-modal="false"
			:before-close="handleClose"
			destroy-on-close>
			<div class="drawer-content">
				<!-- 标签页 -->
				<el-tabs v-model="activeName" @tab-click="handleClick">
					<el-tab-pane label="项目明细" name="1" lazy>
						<el-card class="table-card" shadow="always">
							<div slot="header" class="clearfix">
								<span>项目信息</span>
							</div>
							<el-descriptions :column="2" border>
								<el-descriptions-item label="项目编号">XM-20260420-0002</el-descriptions-item>
								<el-descriptions-item label="项目名称">B栋委托租售项目</el-descriptions-item>
								<el-descriptions-item label="所属小区">南京软件谷项目</el-descriptions-item>
								<el-descriptions-item label="经营类型">委托租售</el-descriptions-item>
								<el-descriptions-item label="经营状态">
									<el-tag type="primary" size="mini">进行中</el-tag>
								</el-descriptions-item>
								<el-descriptions-item label="所属资产" :span="2">
									<el-tag type="info" size="mini" style="margin-right: 6px">B栋301室</el-tag>
									<el-tag type="info" size="mini">B栋302室</el-tag>
								</el-descriptions-item>
							</el-descriptions>
						</el-card>
						<el-card class="table-card" shadow="always">
							<div slot="header" class="clearfix">
								<span>项目周期与收入</span>
							</div>
							<el-descriptions :column="2" border>
								<el-descriptions-item label="开始时间">2026-03-01</el-descriptions-item>
								<el-descriptions-item label="结束时间">2026-08-31</el-descriptions-item>
								<el-descriptions-item label="预计收入">¥50,000</el-descriptions-item>
								<el-descriptions-item label="实际收入">¥30,000</el-descriptions-item>
								<el-descriptions-item label="完成进度" :span="2">
									<el-progress :percentage="29" />
								</el-descriptions-item>
							</el-descriptions>
						</el-card>
						<el-card class="table-card" shadow="always">
							<div slot="header" class="clearfix">
								<span>备注</span>
							</div>
							<div class="remake">暂无备注</div>
						</el-card>
					</el-tab-pane>
					<el-tab-pane label="伙伴信息" name="2" lazy>
						<el-card class="table-card" shadow="always">
							<div slot="header" class="clearfix">
								<span>基本信息</span>
							</div>
							<el-descriptions :column="2" border>
								<el-descriptions-item label="伙伴名称">南京创新科技有限公司</el-descriptions-item>
								<el-descriptions-item label="伙伴类别">租赁商</el-descriptions-item>
								<el-descriptions-item label="类型">公司</el-descriptions-item>
								<el-descriptions-item label="合作状态">
									<el-tag type="success" size="mini">正常</el-tag>
								</el-descriptions-item>
								<el-descriptions-item label="联系人">张三</el-descriptions-item>
								<el-descriptions-item label="联系电话">13800138001</el-descriptions-item>
								<el-descriptions-item label="办公地址">南京市雨花台区软件大道1号</el-descriptions-item>
								<el-descriptions-item label="录入人员">系统管理员</el-descriptions-item>
							</el-descriptions>
						</el-card>
						<el-card class="table-card" shadow="always">
							<div slot="header" class="clearfix">
								<span>业务信息</span>
							</div>
							<el-descriptions :column="2" border>
								<el-descriptions-item label="业务标签" :span="2">
									<el-tag type="primary" style="margin-right: 6px" size="mini">创新租赁</el-tag>
									<el-tag type="warning" size="mini">增值服务</el-tag>
								</el-descriptions-item>
								<el-descriptions-item label="评级等级">A级</el-descriptions-item>
								<el-descriptions-item label="统一社会信用代码">91320100MA1Y123456</el-descriptions-item>
								<el-descriptions-item label="法人代表">王五</el-descriptions-item>
							</el-descriptions>
						</el-card>
						<el-card class="table-card" shadow="always">
							<div slot="header" class="clearfix">
								<span>财务结算信息</span>
							</div>
							<el-descriptions :column="2" border>
								<el-descriptions-item label="开户行">中国工商银行南京软件谷支行</el-descriptions-item>
								<el-descriptions-item label="银行账号">6222 0000 0000 0000 001</el-descriptions-item>
								<el-descriptions-item label="纳税人识别号">91320100MA1Y123456</el-descriptions-item>
								<el-descriptions-item label="保证金金额">¥50,000</el-descriptions-item>
								<el-descriptions-item label="结算周期">按月</el-descriptions-item>
								<el-descriptions-item label="结算方式">银行转账</el-descriptions-item>
								<el-descriptions-item label="分成协议" :span="2">按实际收入70%分成</el-descriptions-item>
							</el-descriptions>
						</el-card>
					</el-tab-pane>
					<el-tab-pane label="合同信息" name="3" lazy>
						<el-card class="table-card" shadow="always">
							<div slot="header" class="clearfix">
								<span>合同信息</span>
							</div>
							<el-descriptions :column="2" border>
								<el-descriptions-item label="合同编号">HT-202604-000001</el-descriptions-item>
								<el-descriptions-item label="合同名称">A栋广告位租赁合同</el-descriptions-item>
								<el-descriptions-item label="甲方（我方）">南京智慧物业有限公司</el-descriptions-item>
								<el-descriptions-item label="乙方（伙伴）">南京创新科技有限公司</el-descriptions-item>
								<el-descriptions-item label="关联项目">A栋广告位创新租赁</el-descriptions-item>
								<el-descriptions-item label="经营类型">创新租赁</el-descriptions-item>
								<el-descriptions-item label="合同状态">
									<el-tag type="success" size="mini">生效中</el-tag>
								</el-descriptions-item>
								<el-descriptions-item label="合同类型">定价合同</el-descriptions-item>
							</el-descriptions>
						</el-card>
						<el-card class="table-card" shadow="always">
							<div slot="header" class="clearfix">
								<span>期限与金额</span>
							</div>
							<el-descriptions :column="2" border>
								<el-descriptions-item label="开始日期">2026-01-01</el-descriptions-item>
								<el-descriptions-item label="结束日期">2026-12-31</el-descriptions-item>
								<el-descriptions-item label="应收总额">¥120,000</el-descriptions-item>
								<el-descriptions-item label="实收金额">¥30,000</el-descriptions-item>
								<el-descriptions-item label="未收金额">¥90,000</el-descriptions-item>
								<el-descriptions-item label="收款进度" :span="2">
									<el-progress :percentage="25" />
								</el-descriptions-item>
							</el-descriptions>
						</el-card>
						<el-card class="table-card" shadow="always">
							<div slot="header" class="clearfix">
								<span>附件</span>
							</div>
							<el-empty description="暂无其他附件"></el-empty>
						</el-card>
					</el-tab-pane>
					<el-tab-pane label="收款记录" name="4" lazy>
						<el-card class="table-card" shadow="always">
							<el-table
								:data="tableData"
								max-height="750"
								border
								style="width: 100%"
								show-summary
								:summary-method="getSummaries">
								<el-table-column prop="incomeType" label="收入类型" width="120" />
								<el-table-column prop="amount" label="收款金额">
									<template #default="{ row }">¥ {{ row.amount.toLocaleString() }}</template>
								</el-table-column>
								<el-table-column prop="payMethod" label="收款方式" width="120" />
								<el-table-column prop="payTime" label="收款时间" width="180" />
								<el-table-column prop="remark" label="备注" />
							</el-table>
						</el-card>
					</el-tab-pane>
				</el-tabs>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		name: 'ProjectManagementDetailDrawer',
		components: {},
		props: {
			dialogVisible: Boolean,
			data: {
				type: Object,
				default: () => ({}),
			},
		},
		watch: {
			dialogVisible(val) {
				if (val) {
					this.$nextTick(() => {
						this.activeName = '1';
					});
				}
			},
		},
		data() {
			return {
				activeName: '1',
				detailData: {},
				tableData: [
					{
						incomeType: '租金',
						amount: 10000,
						payMethod: '银行转账',
						payTime: '2026-01-15 10:30:00',
						remark: '首期款项',
					},
					{
						incomeType: '租金',
						amount: 10000,
						payMethod: '银行转账',
						payTime: '2026-02-15 14:20:00',
						remark: '正常收款',
					},
					{
						incomeType: '租金',
						amount: 10000,
						payMethod: '银行转账',
						payTime: '2026-03-15 09:15:00',
						remark: '正常收款',
					},
					{
						incomeType: '服务费',
						amount: 5000,
						payMethod: '微信',
						payTime: '2026-03-20 16:45:00',
						remark: '增值服务费用',
					},
					{
						incomeType: '租金',
						amount: 10000,
						payMethod: '银行转账',
						payTime: '2026-04-15 11:00:00',
						remark: '正常收款',
					},
				],
			};
		},
		methods: {
			getSummaries(param) {
				const { columns, data } = param;
				const sums = [];
				columns.forEach((column, index) => {
					if (index === 0) {
						sums[index] = '总价';
						return;
					}
					const values = data.map(item => Number(item[column.property]));
					if (!values.every(value => isNaN(value))) {
						sums[index] = values.reduce((prev, curr) => {
							const value = Number(curr);
							if (!isNaN(value)) {
								return prev + curr;
							} else {
								return prev;
							}
						}, 0);
						sums[index] = '¥ ' + sums[index];
					} else {
						sums[index] = '';
					}
				});
				return sums;
			},
			handleClose() {
				this.$emit('update:dialogVisible', false);
			},
			handleClick(tab, event) {
				console.log(tab, event);
			},
		},
	};
</script>

<style scoped lang="scss">
	.drawer-content {
		padding: 10px 24px;
		color: #666;
	}

	.table-card {
		margin-bottom: 10px;
	}

	.remake {
		width: 100%;
		box-sizing: border-box;
		padding: 12px 24px;
		background-color: #eeeeee;
		color: #333;
		border-radius: 6px;
	}
</style>
